export enum PageType {
  LEVEL = 1, // 成交档次
  RULE = 2, // /评级规则
}
